import { computed, makeAutoObservable, reaction } from "mobx"
import schemes from "../../schemes"
import appStore from "../../store"

class ImacrosStore {

  values: { [ key: string ]: string | number } = {
    countModules: 0
  }
  
  arrayValues: { id: number, projects: number, tags: number, time: number, timeType: string }[] = []

  constructor() {
    makeAutoObservable(this, {
      entries: computed.struct
    })

    reaction(() => appStore.currentScheme, () => {
      this.reset()
    })
  }

  get scheme() {
    return schemes[appStore.currentScheme]
  }

  get entries() {

    const keys: [ string, string ][] = []
    const baseKey = [ 'langings', 'V2', this.values.slug, this.scheme.keyName, this.values.id, 'section' ]
      .filter(i => !!i)
      .join('.') + '.'

    const push = (key: string, value: string = "") => {
      keys.push([ baseKey+key, value ])
    }

    for (let keyGroup of this.scheme.definedEntries) {
      for (let key in keyGroup) {
        if (key.startsWith("_") || key === 'slug' || key === 'id') continue
        key in this.values && this.values[key] && push(key, this.values[key].toString())
      }
    }

    if ('definedValues' in this.scheme) {
      for (let key in this.scheme.definedValues) {
        push(key, (this.scheme.definedValues as any)[key])
      }
    }

    const block = this.scheme.blockKeyName
    if (this.values.countModules) {
      push(`${block}s.count`, this.values.countModules.toString())
    }
    
    for (let x = 1; x <= this.arrayValues.length; x++) {
      const el: any = this.arrayValues[x-1]
      this.scheme.row(x, el, (key, value) => push(`${block}.${x}.${key}`, value))
    }

    return keys
  }

  get consoleCode() {
    const arr = []
    arr.push(`
const getElement = (selector, text) => {
  for (const a of document.querySelectorAll(selector)) {
    if (a.textContent.includes(text)) {
      return a
    }
  }
}

const pasteText = (el, text) => {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  nativeInputValueSetter.call(el, text);

  el.dispatchEvent(new Event('input', { bubbles: true}));
}

const pasteTextareaText = (el, text) => {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set;
  nativeInputValueSetter.call(el, text);

  el.dispatchEvent(new Event('input', { bubbles: true}));
}

let el
    `)
    for (let i = 0; i < this.entries.length; i++) {
      if (i > 0) {
        arr.push(`getElement('button', "Добавить ещё").click()`)
      }
      const [ key, value ] = this.entries[i]
      arr.push(`await new Promise(res => setTimeout(res, 10))`)
      arr.push(`el = getElement('h3', 'Ключ ${i+1}').parentElement`)
      arr.push(`pasteText(el.querySelector('input'), "${key}")`)
      arr.push(`pasteTextareaText(el.querySelector('textarea[placeholder="Пустой перевод"]'), "${value}")`)
    }

    return arr.join("\n")
  }

  get imacrosCode() {
    return this.entries.map(([ key, value ], i) => {
      const arr = [
        `TAG POS=${i+1} TYPE=INPUT:TEXT ATTR=* CONTENT=${key}`,
        `TAG POS=${i+1} TYPE=TEXTAREA ATTR=CLASS:editArea_1AG_peIB<SP>textarea_11R-z66b<SP>paddingReset_1k1b9vQu&&ARIA-LABEL:Перевод<SP>на<SP>ru&&PLACEHOLDER:Пустой<SP>перевод&&DIR:ltr CONTENT="${value}"`
      ]
      if (i > 0) {
        arr.unshift(`TAG POS=1 TYPE=BUTTON ATTR=TXT:Добавить<SP>ещё`)
      }

      return arr.join("\n")
    }).join("\n\n")
  }

  get rawCode() {
    return this.entries.map(([ key, value ], i) => {
      return [ key, value ].join("\n")
    }).join("\n\n")
  }

  setValue<Key extends keyof typeof this.values> (key: Key, value: typeof this.values[Key]) {
    this.values[key] = value
  }

  setArrayValue(index: number, key: string, value: string) {
    (this.arrayValues[index] as any)[key] = value
  }
  
  applyCountModules() {
    const count = parseInt(this.values.countModules as any)
    if (isNaN(count)) return
    this.values.countModules = Math.min(count, 200)
    if (this.arrayValues.length > count) {
      this.arrayValues = this.arrayValues.slice(0, count)
    } else {
      for (let i = this.arrayValues.length; i < count; i++) {
        const obj = { id: i+1 }
        for (let key in this.scheme.tableColumns) {
          (obj as any)[key] = (this.scheme.tableColumns as any)[key].default || "0"
        }
        this.arrayValues.push(obj as any)
      }
    }
  }
  
  reset() {
    this.arrayValues = []
    this.values = {
      countModules: 0
    }
  }

}

export default ImacrosStore